import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ButtonM, Content, Section, TextDiv } from "../styles/Common";
import { styled } from "styled-components";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import Img1 from "../styles/images/img_introduce_1.png";
import Img2 from "../styles/images/img_introduce_2.png";
import CompanyList from "../components/list/CompanyList";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../components/hooks/authFunc";
import { mainActions } from "../store/slices/mainSlice";

const IntroducePage = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.main.affiliateList);
  const accessToken = getToken();
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const params = {};
    dispatch(mainActions.fetchAffiliateList({ params }));
  };
  return (
    <OnlyHeaderLayout title={"소개"}>
      <Section>
        <Content>
          <IntroduceTextDiv>
            <IntroduceMuPointDiv>
              <h3>똑똑한 포인트 습관 MU Point</h3>

              <div>
                <img className="img_1" src={`${Img1}`} alt="" />
                <p>
                  <span>뮤포인트</span>는
                  <br />
                  MostUp Alliance 20여개 회원사의
                  <br />
                  포인트를 통합해서 관리할 수 있는 세상에 없던
                  <br />
                  모빌리티 멤버쉽 서비스 입니다.
                </p>
              </div>
              <div>
                <img className="img_2" src={`${Img2}`} alt="" />
                <p>
                  다양한 회원사의 모빌리티 혜택을 포인트로 쌓고 <br />
                  <span>AMO코인</span>으로 교환하세요!
                  <br />
                  포인트를 활용하여 코인으로 교환도 가능 합니다.
                  <br />
                  이제부터 포인트로 투자하는 생활 습관까지!
                  <br />
                </p>
              </div>
            </IntroduceMuPointDiv>
            <IntroduceAffiliateDiv>
              <h3>
                Mu.Point의 <br />
                <span>다양한 제휴사</span>를 소개합니다.
              </h3>
              <More>
                <span
                  to="/introduce/partners"
                  onClick={() => {
                    navigate("/introduce/partners");
                  }}
                  className="col pointer"
                >
                  제휴사 더보기
                </span>
              </More>
              {data && data.count > 0 && (
                <>
                  <CompanyList
                    clickDisabled="false"
                    data={data}
                    page="introducePage"
                  ></CompanyList>
                </>
              )}
            </IntroduceAffiliateDiv>
          </IntroduceTextDiv>
        </Content>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default IntroducePage;

const IntroduceTextDiv = styled(TextDiv)`
  h3 {
    font-family: NanumSquareEB;
    font-size: 2rem;
    font-weight: 800;
    line-height: 2.3rem;
    letter-spacing: 0;
    span {
      color: ${({ theme }) => theme.color.purple_primary};
    }
  }
  p {
    span {
      font-family: NanumSquareB;
    }
  }
`;

const IntroduceMuPointDiv = styled.div`
  padding-bottom: 6rem;
  border-bottom: 1px dashed #919191;
  div:nth-of-type(2) {
    margin-top: 5rem;
    p {
      margin-top: 3.6rem;
    }
  }
  img {
    margin-top: 4.4rem;
    &.img_1 {
      width: 100%;
      max-width: 29.7rem;
    }
    &.img_2 {
      width: 26.8rem;
    }
  }
`;

const IntroduceAffiliateDiv = styled.div`
  padding: 7rem 0 3rem 0;
  ul {
    margin-top: 3.2rem;
  }
`;

const More = styled.div`
  margin-top: 1.3rem;
  span {
    font-family: NanumSquareB;
    font-size: 1.4rem;
    line-height: 2rem;
    letter-spacing: -0.42px;
    text-decoration-line: underline;
  }
`;
